import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function FileUpload (props) {
  return (
    <SvgIcon viewBox="0 0 12 16" {...props}>
      <path
        d="M11.5312 3.0625L8.9375 0.46875C8.65625 0.1875 8.25 0 7.875 0H1.46875C0.65625 0.03125 0 0.6875 0 1.53125V14.5312C0 15.3438 0.65625 16 1.46875 16H10.5C11.3125 16 12 15.3438 12 14.5312V4.125C12 3.75 11.8125 3.34375 11.5312 3.0625ZM8 1.03125C8.0625 1.0625 8.15625 1.09375 8.21875 1.15625L10.8438 3.78125C10.9062 3.84375 10.9375 3.9375 10.9688 4.03125H8V1.03125ZM11 14.5312C11 14.7812 10.75 15.0312 10.5 15.0312H1.46875C1.21875 15.0312 0.96875 14.7812 0.96875 14.5312V1.53125C0.96875 1.25 1.21875 1 1.46875 1H7V4.28125C7 4.6875 7.3125 5 7.75 5H11V14.5312ZM5.34375 6.78125L3.21875 9.03125C2.96875 9.28125 2.90625 9.65625 3.0625 10C3.1875 10.3125 3.5 10.5 3.84375 10.5H5.5V13.25C5.5 13.4062 5.59375 13.5 5.75 13.5H6.25C6.375 13.5 6.5 13.4062 6.5 13.25V10.5H8.125C8.46875 10.5 8.78125 10.3125 8.90625 10C9.0625 9.65625 9 9.28125 8.75 9.03125L6.625 6.78125C6.28125 6.4375 5.6875 6.4375 5.34375 6.78125ZM4.15625 9.5L6 7.5625L7.8125 9.5H4.15625Z"
        fill="black"
      />
    </SvgIcon>
  );
}
